import {observer} from "mobx-react";
import {usePreMatchRate} from "../../../infrastructure/hooks/rates/usePreMatchRate";
import {OptionRate} from "./option-rate";

export const OptionPreMatchRate = observer(({option, controller, className, betsImpressionParams}) => {
  const preMatchRate = usePreMatchRate(controller, option);

  const optionRateProps = {
    controller,
    className,
    betsImpressionParams
  }

  return (
   <OptionRate {...optionRateProps}>
     {preMatchRate}
   </OptionRate>
  )
});

